import React, {PropTypes} from 'react';

const Checkbox = (props) => (
  <div className="input-group-basic item-float-alt">
    <label>
      <input
        className="basic-checkbox"
        type="checkbox"
        defaultChecked={false}
        checked={props.checked}
         onChange={(e) => {props.handleChange()}}/>
      <div className="basic-checkbox-checker"/>
        {props.name}
    </label>
    {props.hint && <i className="info fa fa-question-circle" aria-hidden="true">
      <div className="infobox text-style">
        {props.hint}
      </div>
    </i>}
  </div>
)

export default Checkbox



// WEBPACK FOOTER //
// ./src/browser/components/stateless/Checkbox.react.js